<template>
  <div class="page-container">
    <div class="main">
      <page :url="url" :form="form">
        <template slot="buttonArea">
          <el-button type="primary" @click="add" size="small">{{ $t('text.addAccount') }}</el-button>
        </template>

        <template slot="tableColumn">
          <el-table-column prop="id" :label="$t('text.accountId')" align="center" width="100px"/>
          <el-table-column prop="bankCardName" :label="$t('text.cardName')" align="center" width="150px"/>
          <el-table-column prop="sender" :label="$t('text.sender')" align="center" width="200px"/>
          <el-table-column prop="recipient" :label="$t('text.recipient')" align="center" width="200px"/>
          <el-table-column prop="mailHost" :label="$t('text.mailServiceHost')" align="center" width="150px"/>
          <el-table-column prop="mailPort" :label="$t('text.mailServicePort')" align="center" width="150px"/>
          <el-table-column prop="username" :label="$t('text.username')" align="center" width="200px"/>
          <el-table-column prop="enabled" :label="$t('text.enabled')" align="center" width="100px" :formatter="formatter.formatBoolean"/>
          <el-table-column prop="remarks" :label="$t('text.remark')" align="center" width="300px" :formatter="formatter.formatNullableString"/>
          <el-table-column fixed="right" :label="$t('text.actions')" align="center" width="100px">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" plain @click="edit(scope.row)">{{ $t('text.edit') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </page>

      <MailMonitorInfoEdit :show.sync="showDialog" :value="formData" :action="action"/>
    </div>
  </div>
</template>
<script>
import Page from "@/components/Page.vue";
import formatter from "@/utils/formatter";
import MailMonitorInfoEdit from "@/views/route/mailMonitorInfo/MailMonitorInfoEdit.vue";

export default {
  name: "MailMonitorInfo",
  computed: {
    formatter() {
      return formatter;
    }
  },
  components: {
    page: Page,
    MailMonitorInfoEdit: MailMonitorInfoEdit
  },
  data() {
    return {
      url: "/mailMonitorInfo/selectList",
      action: "",
      showDialog: false,
      formData: null,
      form: {}
    };
  },
  methods: {
    add() {
      this.action = "add";
      this.showDialog = true;
    },
    edit(row) {
      this.action = "edit";
      this.formData = row;
      this.showDialog = true;
    }
  }
};
</script>